import React, { useEffect, useState, useRef } from 'react'
import CommonTable from '@/components/commonTable'
import { Row, Col, Tooltip, Icon } from 'antd'
import { Link } from 'react-router-dom'
import SearchBox from './components/searchBox'
import { getJurisdiction } from '@/statics/js/jurisdiction'
import { _monthOverdueReports, _overdueReportsStatistics } from '@/statics/js/api'
import '../style.less'
const MonthlyPayment = (props) => {
  const { orderStatusItem } = props
  const tableRef = useRef()
  const [overdueDate, setOverdueDate] = useState({
    overdueOrderCount: 0,
    overdueTotalAmount: 0,
  })
  useEffect(() => {
    let fid = localStorage.getItem('type') !== '0' ? localStorage.getItem('fid') : ''
    getOverdueDate({ fid })
  }, [])
  let columns = [
    {
      title: '订单号',
      width: 180,
      dataIndex: 'orderSn',
      render: (text) => (
        <Link target='_blank' to={'/packageOrderManagement?orderSn=' + text}>
          {text}
        </Link>
      ),
    },
    {
      title: '商户名',
      width: 160,
      dataIndex: 'franchiseeName',
    },
    {
      title: '站点',
      width: 150,
      dataIndex: 'siteName',
    },
    {
      title: '订单状态',
      width: 120,
      render: (text) => <span>{orderStatusItem[text.orderStatus - 1]?.title}</span>,
    },
    {
      title: '是否挂起',
      width: 70,
      dataIndex: 'hangUp',
      render: (text) => (text === 0 ? '否' : text === 1 ? '是' : null),
    },
    {
      title: '挂起订单时间',
      width: 100,
      dataIndex: 'hangUpTime',
    },
    {
      title: '已逾期期数',
      width: 80,
      dataIndex: 'overduePeriods',
    },
    {
      title: '已支付期数',
      width: 80,
      dataIndex: 'paidPeriods',
    },
    {
      title: () => (
        <>
          <span>已支付租金</span>&nbsp;
          <Tooltip placement='top' title='该订单累计收到的租金'>
            <Icon type='question-circle' />
          </Tooltip>
        </>
      ),
      width: 80,
      dataIndex: 'paidRentMoneyFormat',
    },
    {
      title: () => (
        <>
          <span>订单逾期开始时间</span>&nbsp;
          <Tooltip placement='top' title='订单逾期时间按合同签约时间计算'>
            <Icon type='question-circle' />
          </Tooltip>
        </>
      ),
      width: 110,
      dataIndex: 'overdueStartTime',
    },
    {
      title: () => (
        <>
          <span>应收未收逾期金额</span>&nbsp;
          <Tooltip placement='top' title='已到支付时间未支付的月扣订单金额'>
            <Icon type='question-circle' />
          </Tooltip>
        </>
      ),
      width: 110,
      dataIndex: 'unpaidOverdueMoneyFormat',
    },
    {
      title: () => (
        <>
          <span>逾期租金违约金</span>&nbsp;
          <Tooltip
            placement='top'
            title={
              <>
                订单租金逾期后会产生一定费用，每期逾期金额*0.5‰*当期逾期天数。多期租金逾期时算出各自逾期租金违约金后相加。
                <br />
                可人工修改
              </>
            }
          >
            <Icon type='question-circle' />
          </Tooltip>
        </>
      ),
      width: 100,
      dataIndex: 'diffMoneyFormat',
    },
    {
      hide: localStorage.getItem('type') !== '0',
      title: '追偿金额',
      width: 100,
      dataIndex: 'recourseMoneyFormat',
    },
    {
      title: '套餐名称',
      width: 150,
      dataIndex: 'packageName',
    },
    {
      title: '套餐类型',
      width: 90,
      dataIndex: 'packagesType',
      render: (text) =>
        text === 1
          ? '租赁'
          : text === 2
          ? '销售'
          : text === 3
          ? '按月起租'
          : text === 4
          ? '连续租赁'
          : null,
    },
    {
      title: '先付/后付',
      width: 100,
      dataIndex: 'deductType',
      render: (text) => (text === 0 ? '--' : text === 1 ? '先付' : text === 2 ? '后付' : null),
    },
    {
      title: '套餐金额',
      width: 90,
      dataIndex: 'packageMoneyFormat',
    },
    {
      title: '合同总期数',
      width: 80,
      dataIndex: 'periodsNum',
    },
    {
      title: () => (
        <>
          <span>合同总租金</span>&nbsp;
          <Tooltip placement='top' title='合同总租金=套餐金额*合同总期数'>
            <Icon type='question-circle' />
          </Tooltip>
        </>
      ),
      width: 80,
      dataIndex: 'rentAmountFormat',
    },
    {
      title: '订单下单时间',
      width: 100,
      dataIndex: 'createTime',
    },
    {
      title: '合同租赁开始时间',
      width: 100,
      dataIndex: 'leaseStartTime',
    },
    {
      title: '合同租赁结束时间',
      width: 100,
      dataIndex: 'leaseEndTime',
    },
    {
      title: '用户姓名',
      width: 90,
      dataIndex: 'username',
    },
    {
      title: '手机号',
      width: 110,
      dataIndex: 'mobile',
    },
    {
      title: '身份证号码',
      width: 120,
      dataIndex: 'idCard',
    },
    {
      title: '数据类型',
      width: 100,
      dataIndex: 'errorData',
      render: (text) => (text === 0 ? '正常数据' : text === 1 ? '异常数据' : null),
    },
    {
      title: '备注',
      width: 100,
      dataIndex: 'remark',
    },
  ]
  columns = columns.filter((item) => !item.hide)
  const getOverdueDate = async ({ fid = '' }) => {
    let params = { fid, type: 2 }
    const res = await _overdueReportsStatistics(params)
    if (res.data.code === 200) {
      setOverdueDate(res.data.data)
    }
  }
  const handleSearch = (params) => {
    tableRef.current.handleSearch(params)
    getOverdueDate({ fid: params.fid })
  }
  return !getJurisdiction(1109) ? (
    '暂无操作权限！'
  ) : (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <div className='centerDiv'>
            总逾期订单数（近1年）
            <span>{overdueDate.overdueOrderCount}</span>笔
          </div>
        </Col>
        <Col span={12}>
          <div className='centerDiv'>
            总逾期金额（近1年）
            <span>{overdueDate.overdueTotalAmountFormat}</span>元
          </div>
        </Col>
      </Row>
      <div className='select-form'>
        <SearchBox search={handleSearch} orderStatusItem={orderStatusItem} />
      </div>
      <CommonTable
        action={_monthOverdueReports}
        showSort
        options={{
          columns: columns,
          scroll: { x: 2600, y: 500 },
        }}
        ref={tableRef}
      />
    </div>
  )
}

export default MonthlyPayment
